export default class HueSaturation {
	constructor() {
		this.hue = {
			minValue: -100,
			maxValue: 100,
			calcValue: 100,
		};

		this.saturation = {
			minValue: -100,
			maxValue: 100,
			calcValue: 100,
		};

		this.opacity = {
			minValue: 0,
			maxValue: 100,
		};
	}

	addBlock(blockNum = lutify.blocks.length) {
		UI.createAdjustmentBlockTemplate("hue-saturation", blockNum);
		var element = UI.getAdjustmentBlock(blockNum);

		$(element)
			.find(".expand_options")
			.trigger("click", [false]);

		$(element)
			.find(".saturation_slider")
			.on("input", _ => this.saturationSliderHandler($(element)));
		$(element)
			.find(".saturation_range")
			.on("change", _ => this.saturationValueHandler($(element)));
		$(element)
			.find(".hue_slider")
			.on("input", _ => this.hueSliderHandler($(element)));
		$(element)
			.find(".hue_range")
			.on("change", _ => this.hueValueHandler($(element)));

		$(element).find(".opacity_slider").on("input", () => this.opacitySliderHandler($(element)));
		$(element).find(".opacity-input").on("change", () => this.opacityInputHandler($(element)));

		UI.initKnob(element, {
			size: 30,
		});

		blocks.add({
			name: "hueSaturation",
			passes: [this.addPass()],
			blockNum,
			blendingMode: 0,
			blendingModeName: "Normal",
			opacity: 100,
			values: {
				hue: 0,
				saturation: 0,
			},
		});
	}

	addPass() {
		let hueSaturationPass = gpu.createHueSaturationShaderPass();
		gpu.addPassToComposer(hueSaturationPass, "toMiddle");
		return hueSaturationPass;
	}

	hueSliderHandler($el) {
		blocks.checkSwitchHandler($el);
		lutify.getActiveBlock().passes[0].enabled = true;

		let hueValue = UI.getAdjustmentBlock_sliderValue($el);
		UI.setAdjustmentBlock_rangeValue($el, hueValue);

		let block = lutify.getActiveBlock();
		block.values.hue = hueValue / this.hue.calcValue;
		this.callGPUHue(block.values.hue);
	}

	hueValueHandler($el) {
		blocks.checkSwitchHandler($el);
		lutify.getActiveBlock().passes[0].enabled = true;

		let hueValue = UI.getAdjustmentBlock_rangeValue($el);

		if (hueValue > this.hue.maxValue) {
			hueValue = this.hue.maxValue;
			UI.setAdjustmentBlock_rangeValue($el, hueValue);
		}
		if (hueValue < this.hue.minValue) {
			hueValue = this.hue.minValue;
			UI.setAdjustmentBlock_rangeValue($el, hueValue);
		}

		UI.setAdjustmentBlock_sliderValue($el, hueValue);
		lutify.getActiveBlock().values.hue = hueValue / this.hue.calcValue;
		this.callGPUHue(lutify.getActiveBlock().values.hue);
	}

	saturationSliderHandler($el) {
		blocks.checkSwitchHandler($el);
		lutify.getActiveBlock().passes[0].enabled = true;

		let saturationValue = UI.getAdjustmentBlock_sliderValue($el, 1);
		UI.setAdjustmentBlock_rangeValue($el, saturationValue, 1);

		let block = lutify.getActiveBlock();
		block.values.saturation = saturationValue / this.saturation.calcValue;
		this.callGPUSaturation(block.values.saturation);
	}

	saturationValueHandler($el) {
		blocks.checkSwitchHandler($el);
		lutify.getActiveBlock().passes[0].enabled = true;

		let saturationValue = UI.getAdjustmentBlock_rangeValue($el, 1);

		if (saturationValue > this.saturation.maxValue) {
			saturationValue = this.saturation.maxValue;
			UI.setAdjustmentBlock_rangeValue($el, saturationValue, 1);
		}
		if (saturationValue < this.saturation.minValue) {
			saturationValue = this.saturation.minValue;
			UI.setAdjustmentBlock_rangeValue($el, saturationValue, 1);
		}

		UI.setAdjustmentBlock_sliderValue($el, saturationValue, 1);
		lutify.getActiveBlock().values.saturation = saturationValue / this.saturation.calcValue;
		this.callGPUSaturation(lutify.getActiveBlock().values.saturation);
	}

	callGPUHue(value) {
		let uniforms = lutify.getActiveBlock().passes[0].uniforms;
		uniforms["hueReds"].value = value;
		uniforms["hueYellows"].value = value;
		uniforms["hueGreens"].value = value;
		uniforms["hueCyans"].value = value;
		uniforms["hueBlues"].value = value;
		uniforms["hueMagentas"].value = value;

		gpu.render();
	}

	callGPUSaturation(value) {
		if (value > 0) value = (1 / 1.5384615) * value;
		let uniforms = lutify.getActiveBlock().passes[0].uniforms;
		uniforms["satReds"].value = value;
		uniforms["satYellows"].value = value;
		uniforms["satGreens"].value = value;
		uniforms["satCyans"].value = value;
		uniforms["satBlues"].value = value;
		uniforms["satMagentas"].value = value;

		gpu.render();
	}

	opacitySliderHandler($element) {
		let opacityValue = $element.find(".opacity_slider").val();
		let calcOpacityValue = opacityValue * 0.01;

		$element.find(".opacity-input").val(opacityValue);

		lutify.getActiveBlock().opacity = opacityValue;
		lutify.getActiveBlock().passes.forEach(pass => {
			pass.uniforms.opacity.value = calcOpacityValue;
		})

		gpu.render();
	}

	opacityInputHandler($element) {
		let opacityValue = $element.find(".opacity-input").val();
		let opacitySlider = $element.find(".opacity_slider");

		if (opacityValue > this.opacity.maxValue) opacityValue = this.opacity.maxValue;
		if (opacityValue < this.opacity.minValue) opacityValue = this.opacity.minValue;

		opacitySlider.val(opacityValue);
		opacitySlider.trigger("input");
	}

	applyChanges($block, values, blockData) {
		let hue = values.hue * this.hue.calcValue;
		let saturation = values.saturation * this.saturation.calcValue;
		UI.setAdjustmentBlock_rangeValue($block, hue);
		UI.setAdjustmentBlock_rangeValue($block, saturation, 1);
		$block.find(".hue_range").trigger("change");
		$block.find(".saturation_range").trigger("change");

		if ('opacity' in blockData) {
			$block.find(".opacity-input").val(parseInt(blockData.opacity));
			$block.find(".opacity-input").trigger("change");
		}
	}
}
